import React, { Component } from "react";
import { withStyles } from "material-ui/styles";

const styles = theme => ({
  container: {
    flex: "1 1 auto",
    minWidth: 0,
    minHeight: 0,
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: theme.palette.background.default,
    overflowY: "auto",
    overflowX: "hidden"
  }
});

class MainContainer extends Component {
  render() {
    const { classes, children } = this.props;

    return (
      <main className={classes.container}>
        {children}
      </main>
    );
  }
}

export default withStyles(styles, { withTheme: true })(MainContainer);
